import { render, staticRenderFns } from "./archivio.vue?vue&type=template&id=5722bafa&scoped=true&"
import script from "./archivio.vue?vue&type=script&lang=ts&"
export * from "./archivio.vue?vue&type=script&lang=ts&"
import style0 from "./archivio.vue?vue&type=style&index=0&id=5722bafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722bafa",
  null
  
)

export default component.exports